import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPropertyConfig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_143_3285)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M17.0002 3V4C16.9902 7.352 15.3202 10.023 11.9922 12.014C8.66419 14.004 15.3282 10.014 12.0002 12C8.67219 13.99 7.00019 16.662 6.99219 20.014V21.014",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.0002 21.014V20.014C16.9902 16.662 15.3202 13.991 11.9922 12C8.66419 10.01 15.3282 14 12.0002 12.014C8.67219 10.023 7.00019 7.352 6.99219 4V3",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7 4H17",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7 20H17",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 8H16",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 16H16",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_143_3285",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgPropertyConfig;
